import React, { createContext, useContext, useState, useEffect } from 'react';

const PrivacyContext = createContext();

export const PrivacyProvider = ({ children }) => {
  const [isPrivate, setIsPrivate] = useState(() => {
    const saved = localStorage.getItem('privacyMode');
    return saved ? JSON.parse(saved) : false;
  });

  const togglePrivacy = () => {
    setIsPrivate(prev => {
      const newValue = !prev;
      localStorage.setItem('privacyMode', JSON.stringify(newValue));
      return newValue;
    });
  };

  return (
    <PrivacyContext.Provider value={{ isPrivate, togglePrivacy }}>
      {children}
    </PrivacyContext.Provider>
  );
};

export const usePrivacy = () => {
  const context = useContext(PrivacyContext);
  if (!context) {
    throw new Error('usePrivacy must be used within PrivacyProvider');
  }
  return context;
};
